export enum SolicitudTiposEnum {
    AFT = 'AFT',
    CEC = 'CEC',
    RIB = 'RIB',
    RIT = 'RIT',
    AFB = 'AFB',
    AFD = 'AFD',
    ACM = 'ACM',
    RTM = 'RTM',
    NCM = 'NCM',
    ND = 'ND',
}

export enum SolicitudTiposIdEnum {
    AFT = 0,
    CEC = 1,
    RIB = 2,
    RIT = 3,
    AFB = 4,
    AFD = 5,
    ACM = 6,
    RTM = 7,
    NCM = 8,
    ND = 9,
}

export function obtenerSolicitudTipoId(solicitudTipo: SolicitudTiposEnum): number {
    return SolicitudTiposIdEnum[solicitudTipo as keyof typeof SolicitudTiposIdEnum];
}
